/*
 * Copyright (c) 2026 SimplyBook.me Ltd. All rights reserved.
 * Licensed under the Apache License, Version 2.0.
 */

import { useInfiniteQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { fetcher } from "./fetcher";
import { queryKeys, mutationKeys } from "./queryKeys";

const ON_PAGE = 5;

export const useWaitingList = (params, options = {}) => {
  return useInfiniteQuery({
    ...options,
    queryKey: queryKeys.waitingList.list(params),
    queryFn: ({ pageParam = 1 }) =>
      fetcher({
        method: "GET",
        url: "/public/waiting-list",
        params: { ...params, page: pageParam, on_page: ON_PAGE },
      }),
    staleTime: 0,
    gcTime: 0,
    initialPageParam: 1,
    getNextPageParam: (lastPage) =>
      lastPage.metadata.pages_count > lastPage.metadata.page ? lastPage.metadata.page + 1 : undefined,
  });
};

export const fetchWaitingListItem = (queryClient, id) =>
  queryClient.fetchQuery({
    queryKey: queryKeys.waitingList.item(id),
    queryFn: () => fetcher({ method: "GET", url: `/public/waiting-list/item/id/${id}` }),
    retry: false,
    staleTime: 0,
    gcTime: 0,
  });

export const useCancelWaitingListItem = (id) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationKey: mutationKeys.cancelWaitingListItem(id),
    mutationFn: () => fetcher({ method: "DELETE", url: `/public/waiting-list/item/id/${id}` }),
    onSuccess: () => queryClient.invalidateQueries({ queryKey: queryKeys.waitingList.all }),
  });
};
